export function Logistics() {
  return (
    <section className="py-32 bg-white" aria-labelledby="philosophy-title">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row gap-20 items-center">
          <div className="w-full md:w-1/2">
            <div className="space-y-4 mb-12">
              <div className="w-12 h-2 bg-salt-orange"></div>
              <h2
                id="philosophy-title"
                className="text-5xl font-black uppercase tracking-tighter leading-none text-salt-dark"
              >
                Logistics Built for <br />
                the Field.
              </h2>
            </div>
            <p className="text-xl text-gray-600 font-medium leading-relaxed mb-8">
              Your crews are ready. Your clients are waiting. The only thing
              missing is the material. We specialize in{" "}
              <strong className="text-salt-dark">de-icing salt supply</strong>{" "}
              and{" "}
              <strong className="text-salt-dark">
                wholesale plant sourcing
              </strong>{" "}
              across the Ohio Valley and Mid-South regions.
            </p>
            <div className="grid grid-cols-2 gap-8 mb-8">
              <div>
                <h3 className="font-black uppercase tracking-widest text-xs text-gray-500 mb-2">
                  Primary Service Area
                </h3>
                <p className="font-black text-gray-900">KY / TN / OH / IN</p>
              </div>
              <div>
                <h3 className="font-black uppercase tracking-widest text-xs text-gray-500 mb-2">
                  Inventory Access
                </h3>
                <p className="font-black text-gray-900">
                  100+ Regional Growers
                </p>
              </div>
            </div>
            <a
              className="inline-block bg-salt-dark text-white px-8 py-4 rounded-md font-black uppercase tracking-widest hover:bg-gray-800 transition-colors shadow-lg text-sm"
              href="/"
            >
              See Our Process
            </a>
          </div>
          <div className="w-full md:w-1/2 grid grid-cols-1 gap-4">
            <article className="bg-gray-50 p-10 border-l-8 border-salt-orange rounded-r-2xl shadow-sm">
              <h3 className="text-2xl font-black uppercase mb-4 text-salt-dark">
                Bulk Salt Delivery Logistics
              </h3>
              <p className="text-gray-500 font-bold leading-relaxed mb-6">
                Direct-from-terminal rock salt coordination. When local supply
                yards run dry during winter storms, we find the tonnage you need
                to keep your routes clear and crews working. We also source
                bagged rock salt, ice melt products, and liquid brine products
                for comprehensive deicing coverage.
              </p>
            </article>
            <article className="bg-gray-50 p-10 border-l-8 border-plant-green rounded-r-2xl shadow-sm">
              <h3 className="text-2xl font-black uppercase mb-4 text-salt-dark">
                Landscape Plant Sourcing
              </h3>
              <p className="text-gray-500 font-bold leading-relaxed mb-6">
                Specimen trees, wholesale shrubs, and hard-to-find landscaping
                materials. We connect landscape contractors with premium growers
                for on-time site delivery across the Eastern US.
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}
